import dadosAgenciaComum from './dadosAgenciaComum';

export const dadosJackMultiVendas = {
    ...dadosAgenciaComum,
    id: 'jackmultivendas',
    nome: 'Jack MultiVendas',
    instagram: 'instagram.com',
    facebook: 'facebook.com',
    youtube: 'youtube.com',
    email: 'suportevexado@gmail.com',
    idsTagManager: ['GTM-NHVKV45']
};
